import { useTicketContext } from '@Context/TicketContext';

interface Props {
  selectedFilter: string;
  handleFilter: (filter: string) => void;
  toggleDropdown: () => void;
}

const Filter: React.FC<Props> = ({
  selectedFilter,
  handleFilter,
  toggleDropdown,
}) => {
  const { tickets } = useTicketContext();
  const filters = Array.from(
    new Set(
      tickets.map((ticket) => ticket.workflow_status?.name ?? 'Status Unknown!')
    )
  );
  filters.push('All Tickets');
  filters.sort();

  const handleSelect = (filter: string) => {
    handleFilter(filter);
    toggleDropdown();
  };

  return (
    <div
      onMouseLeave={toggleDropdown}
      className="absolute right-0 top-0 z-10 mt-12 w-1/2 rounded border border-gray-300 bg-white p-2 shadow-lg"
    >
      <ul className="custom-scroll max-h-60 overflow-auto px-2 py-1 font-inter text-sm">
        {filters.map((filter, index) => (
          <li
            data-testid={`test-filter-${filter}`}
            key={index}
            onClick={() => handleSelect(filter)}
            className={`${selectedFilter === filter ? 'bg-primary-700 text-white' : 'hover:bg-primary-100'} cursor-pointer rounded-md px-4 py-2`}
          >
            {filter}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Filter;
